module.exports = __webpack_public_path__ + "static/media/undo-icon-disabled.caf06eb5.svg";